module.exports = __webpack_public_path__ + "img/movingboard.2e8a9c1c.jpeg";